const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSymbolTeal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 298 298",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M297.72,18C297.72,8.066 289.654,0 279.72,0L18,0C8.066,0 0,8.066 0,18L0,279.72C0,289.654 8.066,297.72 18,297.72L279.72,297.72C289.654,297.72 297.72,289.654 297.72,279.72L297.72,18ZM240.37,191.03C228.04,249.59 199.92,268.08 141.37,268.08L110.89,268.08L118.21,233.41L137.08,233.41C173.3,233.41 189.86,215.3 197.57,179.09L222.26,63.86L267.34,63.86L240.37,191.03ZM59.69,105.31C72.02,46.75 100.14,28.31 158.69,28.31L189.12,28.31L181.8,62.98L162.94,62.98C126.72,62.98 110.16,81.09 102.45,117.3L77.8,232.44L32.72,232.44L59.69,105.31Z",
    style: {
      fill: "#0A5F6F"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbolTeal);
export default __webpack_public_path__ + "static/media/logo-symbol-teal.58059e4015f7d3417f056b498a61ca64.svg";
export { ForwardRef as ReactComponent };